import { ReactNode } from "react";
import tw from "twin.macro";

type Props = {
  title?: string;
  children: ReactNode;
  padding?: boolean;
  key?: string;
  mobileBorder?: boolean;
  noBorder?: boolean;
  transparent?: boolean;
  dark?: boolean;
};

const Panel: React.FC<Props> = ({
  title,
  children,
  padding = true,
  mobileBorder = true,
  dark = false,
  noBorder,
  transparent,
}: Props): JSX.Element => (
  <div
    css={[
      tw`lg:border lg:border-gray-300 rounded-2xl relative`,
      padding && tw`p-3`,
      mobileBorder && tw`border border-gray-300`,
      dark && tw`bg-black border border-black`,
      noBorder && tw`border-hidden border-none`,
      transparent ? tw`bg-transparent` : tw`bg-white`,
    ]}
  >
    {title && (
      <div className="mb-4 flex w-full flex-row items-center gap-2 border-b pb-1 text-base font-semibold">
        {title}
      </div>
    )}
    {children}
  </div>
);

export default Panel;
